<template>
  <v-row class="mt-1">
    <v-col cols="10">
      <kicklet-text-field
        class="notranslate"
        :readonly="true"
        :label="label"
        :model-value="input"
        :base-color="isCopied ? 'primary' : 'white'"
        :type="secret && !showSecret ? 'password' : 'text'"
        :hide-details="true"
      >
        <template #append-inner v-if="secret">
          <v-icon icon="mdi-eye" class="mr-3" @click="revealSecret" />
        </template>
      </kicklet-text-field>
    </v-col>
    <v-col cols="2">
      <v-tooltip location="top" :text="$t('copy')">
        <template v-slot:activator="{ props }">
          <v-btn
            :variant="utils.buttonIconVariant"
            v-bind="props"
            color="primary"
            :disabled="isCopied"
            :icon="isCopied ? 'mdi-check' : 'mdi-content-copy'"
            @click="copy"
          />
        </template>
      </v-tooltip>
    </v-col>
  </v-row>
</template>

<script setup>
import KickletTextField from '@/components/custom/kicklet/KickletTextField.vue';
import { ref } from 'vue';

const props = defineProps({
  input: {
    type: String,
    required: true,
  },
  label: {
    type: String,
    default: '',
  },
  secret: {
    type: Boolean,
    default: false,
  },
});

const isCopied = ref(false);
const showSecret = ref(false);

function copy () {
  navigator.clipboard.writeText(props.input);
  isCopied.value = true;
  setTimeout(() => {
    isCopied.value = false;
  }, 1000);
}

function revealSecret () {
  showSecret.value = !showSecret.value;
}
</script>

<style scoped>

</style>
